import React, {useEffect, useState, Fragment} from 'react'
import clsx from 'clsx'
import {
  makeStyles,
  Typography,  
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  TablePagination,
  MenuItem,
  Drawer,  
  Select,  
  Tabs,
  Tab,
  Box,  
  Modal,  
  ButtonBase,
  CircularProgress,
  Checkbox,  
  Fab,
} from '@material-ui/core'
import moment from 'moment'
import Cookies from 'js-cookie'
import BarChart from '../charts/BarChart'
import EventTabTable from './EventTabTable'
import { InfoOutlined } from '@material-ui/icons'
import { BiLeftArrowAlt } from 'react-icons/bi'
import { IoCloseSharp } from 'react-icons/io5'
import noImage from '../../assets/noImage.png'
import TentpoleRoiExcel from '../tentpole/TentpoleRoiExcel'
import PromoPanel from '../tentpole/PromoPanel'
import { filter } from 'lodash'
import EventPromoDrawer from './EventPromoDrawer'
import EventRoiExcel from './EventRoiExcel'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"

const TabPanel = (props) => {
  const { children, value, index, ...other } = props

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Typography>
  )
}

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`
  }
}

const useStyles = makeStyles(theme => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    overflowX: 'scroll',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: '50%',
    marginLeft: 5,
  },
  chartContent: {    
    display: "flex", 
    justifyContent: "space-around", 
    alignItems: "center",               
  },
  chartShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    // marginRight: "-30px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",    
  },
}))

const EventRoiDrawer = (props) => {
  const { data, dataType, marketData, jobID, handleDrawerClose, secondaryOpen, secondaryTab, darkMode } = props  
  const classes = useStyles()
  const token = Cookies.get("token")
  const categoryColors = ["#fc5664", "#cb85ff", "#4b92cc", "#9ac967", "#6ec6cc", "#f27272", "#f27272", "#f27272", "#deb40d", "#8ebf56", "#8ebf56", "#de7c0d",]  
  const [filters, setFilters] = useState({extended: dataType, metricType: "Location", locations: ["All"], rfms: ["All"], testGroups: ["All"]})
  const [filterOptions, setFilterOptions] = useState({locationsList: [], rfmsList: [], testGroupsList: []})
  const [checkedOptions, setCheckedOptions] = useState({locations: [], rfms: [], testGroups: []})
  const [jobData, setJobData] = useState({marketData: null, locationData: null, rfmData: null, testData: null})
  const [roiData, setRoiData] = useState(null)
  const [creatives, setCreatives] = useState(null)  
  const [tab, setTab] = useState(secondaryTab ? secondaryTab : 0)
  const [modalOpen, setModalOpen] = useState(false)
  const [modalImg, setModalImg] = useState(null)
  const [openDrawer, setOpenDrawer] = useState(false)

  const getRoiData = (data, extendedType) => {        
    let total = data.map(item => item[extendedType][0]).reduce((a,b) => {
      for(const prop in b) {
        if(a.hasOwnProperty(prop) && prop !== "MaxWrittenDate" && (prop !== 'PromoEndDate') && (prop !== 'PromoStartDate')) a[prop] += b[prop] 
        else a[prop] = b[prop]
      }
      return a
    }, {})
    
    total.Res_Rate = total.Mailed > 0 ? total.Responses / total.Mailed : 0
    total.HO_Res_Rate = total.HO_Count > 0 ? total.HO_Resp / total.HO_Count : 0
    return total    
  }
  
  const getJobData = () => {            
    const request = Promise.all([
      fetch(`${base_url}/tentpoleROI/jobID/${jobID}/market`, {headers: {"token": token}}),
      fetch(`${base_url}/tentpoleROI/jobID/${jobID}/location`, {headers: {"token": token}}),
      fetch(`${base_url}/tentpoleROI/jobID/${jobID}/rfm`, {headers: {"token": token}}),
      fetch(`${base_url}/tentpoleROI/jobID/${jobID}/test`, {headers: {"token": token}}),
    ])
    .then(([response, response2, response3, response4,]) => Promise.all([response.json(), response2.json(), response3.json(), response4.json()]))
    .then(([data, data2, data3, data4]) => {
      if(data) {
        setJobData(prevState => ({...prevState, marketData: data, locationData: data2, rfmData: data3, testData: data4}))      
        setRoiData(getRoiData(data2, filters.extended))
        setFilterOptions(prevState => ({
          ...prevState, 
          locationsList: data2.map(({Label}) => Label), 
          rfmsList: data3.map(({Label}) => Label),
          testGroupsList: data4.map(({Label}) => Label)
        }))
        setCheckedOptions(prevState => ({
          ...prevState, 
          locations: data2.map(({Label}) => Label), 
          rfms: data3.map(({Label}) => Label),
          testGroups: data4.map(({Label}) => Label)
        }))        
      }
    })
  }

  useEffect(() => getJobData(), [props])

  if(!roiData) return <CircularProgress />  

  const getData = (checked, filterName) => {    
    const { metricType, extended } = filters
    let params = {...checkedOptions}    
    let locType = metricType === "Location" ? "list_loc" : "list_mkt"
    
    params[filterName] = checked

    Object.keys(params).forEach((param) => {      
      if(params[param].length < filterOptions[`${param}List`].length) params[param] = params[param].join("|")
      else params[param] = ""
    })
    
    const request = Promise.all([
      fetch(`${base_url}/tentpoleROI/jobID/${jobID}/location?${locType}=${params["locations"]}&list_rfm=${params["rfms"]}&list_test=${params["testGroups"]}`, {headers: {token: token}}),
      fetch(`${base_url}/tentpoleROI/jobID/${jobID}/rfm?${locType}=${params["locations"]}&list_rfm=${params["rfms"]}&list_test=${params["testGroups"]}`, {headers: {token: token}}),
      fetch(`${base_url}/tentpoleROI/jobID/${jobID}/test?${locType}=${params["locations"]}&list_rfm=${params["rfms"]}&list_test=${params["testGroups"]}`, {headers: {token: token}}),
      fetch(`${base_url}/tentpoleROI/jobID/${jobID}/market?${locType}=${params["locations"]}&list_rfm=${params["rfms"]}&list_test=${params["testGroups"]}`, {headers: {token: token}}),
    ])
    
    if(checked.length > 0) {
      request.then(([response, response2, response3, response4]) => Promise.all([response.json(), response2.json(), response3.json(), response4.json()]))
      .then(([data, data2, data3, data4]) => {
        if(metricType === "Location") setRoiData(getRoiData(data, extended))        
        else setRoiData(getRoiData(data4, extended))
        setJobData(prevState => ({...prevState, 
          marketData: data4,
          locationData: data,
          rfmData: data2,
          testData: data3
        }))
      })
      .catch(error => console.log(error))
    } else {
      setRoiData([])
      setJobData(prevState => ({...prevState, 
        marketData: [],
        locationData: [],
        rfmData: [],
        testData: []
      }))
    }
  }
  
  const getChartData = () => {
    let data = [{name: "Sales", data: []}, {name: "Total_Sales", data: []}]

    for(let j = 0; j < jobData.marketData.length; j++) {
      for(let i = 0; i < data.length; i++) {
        data[i].data.push(Math.round(jobData.marketData[j][dataType][0][data[i].name]))
      }
    }

    return data
  }

  const handleSelectChange = (e, filterName) => {
    const {value} = e.target
    const {extended} = filters
    let newMetricType = `${value.toLowerCase()}Data`
    
    setFilters(prevState => ({...prevState, [filterName]: value}))
    if(filterName === "metricType") {
      let params = {...checkedOptions}      

      Object.keys(params).forEach((param) => {      
        if(params[param].length < filterOptions[`${param}List`].length) params[param] = params[param].join("|")
        else params[param] = ""
      })
      
      const request = Promise.all([        
        fetch(`${base_url}/tentpoleROI/jobID/${jobID}/location?list_rfm${params["rfms"]}&list_test=${params["testGroups"]}`, {headers: {token: token}}),
        fetch(`${base_url}/tentpoleROI/jobID/${jobID}/market?list_rfm${params["rfms"]}&list_test=${params["testGroups"]}`, {headers: {token: token}}),
      ])
      
      request.then(([response, response2]) => Promise.all([response.json(), response2.json()]))
      .then(([data, data2]) => {
        if(value === "Location") {
          setCheckedOptions(prevState => ({...prevState, locations: data.map(({Label}) => Label)}))
          setFilterOptions(prevState => ({...prevState, locationsList: data.map(({Label}) => Label)}))
          setRoiData(getRoiData(data, extended))
          setJobData(prevState => ({...prevState, locationData: data, marketData: data2}))
        } else {
          setCheckedOptions(prevState => ({...prevState, locations: data2.map(({Label}) => Label)}))
          setFilterOptions(prevState => ({...prevState, locationsList: data2.map(({Label}) => Label)}))
          setRoiData(getRoiData(data2, extended))
          setJobData(prevState => ({...prevState, locationData: data, marketData: data2}))
        }
      })
      .catch(error => {console.log(error)})      
    }
                
    if(filterName === "extended") {      
      setRoiData(getRoiData(jobData[`${filters.metricType.toLowerCase()}Data`], value))
    } else setRoiData(getRoiData(jobData[newMetricType], filters.extended))
  }

  const handleChangeFilters = (e, filterName) => {
    const {value} = e.target
    let selected = value.filter(item => item !== "All")[0]
    let checked = [...checkedOptions[filterName]]
    let currentIdx = checked.indexOf(selected)    
    
    if(currentIdx !== -1 && value.length > 0) {      
      checked = checked.filter(item => item !== selected)
      setCheckedOptions(prevState => ({...prevState, [filterName]: checked}))      
    } else if(value.length === 0) {      
      if(checked.length < filterOptions[`${filterName}List`].length) {        
        checked = filterOptions[`${filterName}List`]
        setCheckedOptions(prevState => ({...prevState, [filterName]: filterOptions[`${filterName}List`]}))
      } else {        
        checked = []
        setCheckedOptions(prevState => ({...prevState, [filterName]: []}))
      }
    } else {      
      checked.push(selected)
      setCheckedOptions(prevState => ({...prevState, [filterName]: checked}))      
    }    
    console.log(checked)
    getData(checked, filterName)
  }

  const handleClose = (e) => {
    handleDrawerClose(e)
    // setRoiData(null)
  }

  const handleTabChange = (e, tab) => {
    setTab(tab)
  }

  const handleOpenCreative = (e) => {
    const { src } = e.target
    setModalImg(src)
    setModalOpen(true)
  }

  const handleCloseCreative = () => {
    setModalImg(null)
    setModalOpen(false)
  }

  const openPromotionDrawer = () => {
    setOpenDrawer(true)
  }

  const closePromotionDrawer = () => {    
    setOpenDrawer(false)
  }

  const renderStatusTable = (roiData) => {    
    
    const {Cost, Mailed, Responses, Sales, Res_Rate, Total_Sales, HO_Count, HO_Sales, HO_Resp, HO_Res_Rate} = roiData    

    return (
      <Table className="status-table" size="small">
        <TableHead>
          <TableRow>
            <TableCell><Typography className={`table-head ${darkMode ? "dk" : "lt"}`}>Status</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography className={`table-head`} style={{color: categoryColors[0]}}>Spend</Typography></TableCell>
            <TableCell align="right"><Typography className={`table-head`} style={{color: categoryColors[1]}}>Mailed</Typography></TableCell>
            <TableCell align="right"><Typography className={`table-head`} style={{color: categoryColors[2]}}>Responses</Typography></TableCell>
            <TableCell align="right"><Typography className={`table-head`} style={{color: categoryColors[3]}}>Sales</Typography></TableCell>
            <TableCell align="right"><Typography className={`table-head`} style={{color: categoryColors[4]}}>Response Rate</Typography></TableCell>
            <TableCell align="right"><Typography className={`table-head`} style={{color: categoryColors[5]}}>DM CoA (%)</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography className={`table-head`} style={{color: categoryColors[6]}}>Cost Per Thousand</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography className={`table-head`} style={{color: categoryColors[7]}}>Total CoA(%)</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography className={`table-head`} style={{color: categoryColors[8]}}>Average Ticket</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography className={`table-head`} style={{color: categoryColors[9]}}>Total Sales</Typography></TableCell>
            <TableCell align="right"><Typography className={`table-head`} style={{color: categoryColors[10]}}>% of Total Sales</Typography></TableCell>
            <TableCell align="right"><Typography className={`table-head`} style={{color: categoryColors[11]}}>Contribution Margin ROI</Typography></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className="event-table-row">
            <TableCell><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>Mailed</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Math.round(Cost).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Math.round(Mailed).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Math.round(Responses).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Math.round(Sales).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{(Res_Rate * 100).toFixed(2)}%</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Sales > 0 ? (Cost / Sales * 100).toFixed(2) : 0}%</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Mailed > 0 ? Math.round(Cost / Mailed * 1000).toLocaleString("en") : 0}</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Total_Sales > 0 ? (Cost / Total_Sales * 100).toFixed(2) : 0}%</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Responses > 0 ? Math.round(Sales / Responses).toLocaleString("en") : 0}</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Math.round(Total_Sales).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Total_Sales > 0 ? (Sales / Total_Sales * 100).toFixed(2) : 0}%</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>N/A</Typography></TableCell>
          </TableRow>
          <TableRow className="event-table-row">
            <TableCell><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>Holdout</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${0}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Math.round(HO_Count).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Math.round(HO_Resp).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Math.round(HO_Sales).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{(HO_Res_Rate * 100).toFixed(2)}%</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{null}</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{null}</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{null}</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${HO_Resp > 0 ? Math.round(HO_Sales / HO_Resp).toLocaleString("en") : 0}</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Math.round(Total_Sales).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Total_Sales > 0 ? (HO_Sales / Total_Sales * 100).toFixed(2) : 0}%</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>N/A</Typography></TableCell>
          </TableRow>
          <TableRow className="event-table-row">
            <TableCell><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>Adjusted</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Math.round(Cost).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Math.round(Mailed).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Res_Rate - HO_Res_Rate > 0 ? Math.round(Mailed * (Res_Rate - HO_Res_Rate)).toLocaleString("en") : 0}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Res_Rate - HO_Res_Rate > 0 ? Math.round(Sales / Res_Rate * (Res_Rate - HO_Res_Rate)).toLocaleString("en") : 0}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Res_Rate - HO_Res_Rate > 0 ? ((Res_Rate - HO_Res_Rate) * 100).toFixed(2) : 0}%</Typography></TableCell>
            <TableCell align="right" name="DMCOA"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Res_Rate - HO_Res_Rate > 0 ? (Cost / (Sales / Res_Rate * (Res_Rate - HO_Res_Rate)) * 100).toFixed(2) : 0}%</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Mailed > 0 ? Math.round(Cost / Mailed * 1000).toLocaleString("en") : 0}</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Total_Sales > 0 ? (Cost / Total_Sales * 100).toFixed(2) : 0}%</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Res_Rate - HO_Res_Rate > 0 ? Math.round((Sales / Res_Rate * (Res_Rate - HO_Res_Rate)) / (Mailed * (Res_Rate - HO_Res_Rate))).toLocaleString("en") : 0}</Typography></TableCell>
            <TableCell align="right" className={openDrawer || secondaryOpen ? "hide" : ""}><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>${Math.round(Total_Sales).toLocaleString("en")}</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>{Res_Rate - HO_Res_Rate > 0 ? ((Sales / Res_Rate * (Res_Rate - HO_Res_Rate)) / Total_Sales * 100).toFixed(2) : 0}%</Typography></TableCell>
            <TableCell align="right"><Typography variant="caption" className={`table-col ${darkMode ? "dk" : "lt"}`}>N/A</Typography></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }

  const renderModal = () => (    
    <Modal
      open={modalOpen}
      onClose={handleCloseCreative}
      closeAfterTransition
      BackdropProps={{timeout: 500}}
      className="event-modal"
    >
      <img className="img" src={modalImg} alt="" />
    </Modal>    
  )

  const renderDrawer = () => (
    <Drawer
      className="promotion-drawer"
      variant="persistent"
      anchor="right"
      open={openDrawer}
      classes={{paper: `promo-drawer-paper ${darkMode ? "bg-dk" : "bg-lt"}`}}
    >      
      <EventPromoDrawer 
        closePromotionDrawer={closePromotionDrawer}
        secondaryOpen={openDrawer}
        tab={tab}
        dateExtended={filters.extended}
        openJob={jobID}
        darkMode={darkMode}
      />    
    </Drawer>
  )

  return (
    <div className={`event-roi-drawer ${darkMode ? "bg-dk" : "bg-lt"}`}>
      <main className={clsx(classes.content, {[classes.contentShift]: openDrawer})}>      
        <div>
          <div style={{color: `${darkMode ? "#fff" : "#6e6e6e"}`, padding: "1em"}}>
            <Fab size="small" onClick={handleClose} style={{backgroundColor: "#e04d4a"}}>
                <IoCloseSharp style={{color: "#fff"}} />
            </Fab>
            <Typography variant="caption" style={{marginLeft: "5px"}}>
              CLOSE
            </Typography>
          </div>
          <br/>
          <div className="filter-group">
            <div style={{justifyContent: "space-evenly"}}>            
              <Select
                value={filters.extended}
                onChange={(e) => handleSelectChange(e, "extended")}                
                className={`roi-drawer-select ${darkMode ? "dk" : "lt"}`}
              >
                <MenuItem value={"Data_Extended"}><Typography variant="caption">EXTENDED DATE</Typography></MenuItem>
                <MenuItem value={"Data_Promo"}><Typography variant="caption">PROMO DATE</Typography></MenuItem>
              </Select>  
              <Select
                value={filters.metricType}
                onChange={(e) => handleSelectChange(e, "metricType")}                
                className={`roi-drawer-select ${darkMode ? "dk" : "lt"}`}
                style={{marginLeft: "15px"}}
              >
                <MenuItem value={"Location"}><Typography variant="caption">BY LOCATION</Typography></MenuItem>
                <MenuItem value={"Market"}><Typography variant="caption">BY MARKET</Typography></MenuItem>
              </Select>
                          
              {Object.keys(filterOptions).map((option, i) => (
                <Select
                  key={`${option}`}
                  value={filters[option.split("List")[0]]}
                  multiple                  
                  className={`roi-drawer-select ${darkMode ? "dk" : "lt"}`}
                  style={{marginLeft: "15px"}}
                  onChange={e => handleChangeFilters(e, option.split("List")[0])}
                  renderValue={() => (
                    checkedOptions[option.split("List")[0]].length !== filterOptions[option].length ?
                      <div>
                        <Typography variant="caption">{`${checkedOptions[option.split("List")[0]].length} ${option !== "locationsList" ? option.split("List")[0].toUpperCase() : filters.metricType.toUpperCase() + "S"}`}</Typography>
                      </div>
                    :
                      <div>
                        <Typography variant="caption">{option !== "locationsList" ? `ALL ${option.split("List")[0].toUpperCase()}` : `ALL ${filters.metricType.toUpperCase()}S`}</Typography>
                      </div>
                  )}
                >
                  <MenuItem value={"All"}>
                    <Typography variant="caption">
                      {filterOptions[option].length === checkedOptions[option.split("List")[0]].length ? "DESELECT" : null} ALL {option !== "locationsList" ? option.split("List")[0].toUpperCase() : `${filters.metricType.toUpperCase()}S`}
                    </Typography>
                  </MenuItem>
                  {filterOptions[option].length >= 1 ?
                    filterOptions[option].map((item, i) => (                  
                      <MenuItem key={`${item}-${i}`} value={item}>
                        <Checkbox edge="start" size="small" disableRipple checked={checkedOptions[option.split("List")[0]].indexOf(item) !== -1}/>
                        <Typography variant="caption">{item.toUpperCase()}</Typography>                        
                      </MenuItem>
                    ))
                  :
                    null
                  }
                </Select>
              ))}            
            </div>
            <div>
              <Typography 
                className={openDrawer || secondaryOpen ? "hide" : "expand-btn"}
                onClick={openPromotionDrawer} 
                style={{marginRight: "15px"}}
              >
                COMPARE TO ANOTHER PROMOTION
              </Typography>              
                            
              <div className="event-excel">                            
                <EventRoiExcel
                  promoName={data[0].Promotion}
                  format={data[0].Format_Desc}
                  selectedType={filters.metricType}
                  markets={checkedOptions.locations}
                  selectedRfm={checkedOptions.rfms}
                  selectedTestGroups={checkedOptions.testGroups}
                  roiData={roiData}
                  locationData={jobData.locationData}
                  rfmData={jobData.rfmData}
                  testData={jobData.testData}
                  dateExtended={filters.extended}
                />
              </div>              
            </div>
          </div>
        </div>      
        <Table className="table promo">
          <TableHead>
            <TableRow style={{height: "60px"}}>
              <TableCell><Typography className={`table-head ${darkMode ? "dk" : "lt"}`}>PROMOTION</Typography></TableCell>
              <TableCell align="right"><Typography className={`table-head ${darkMode ? "dk" : "lt"}`}>REPORT START</Typography></TableCell>
              <TableCell align="right"><Typography className={`table-head ${darkMode ? "dk" : "lt"}`}>REPORT END</Typography></TableCell>
              <TableCell align="right"><Typography className={`table-head ${darkMode ? "dk" : "lt"}`}>FORMAT</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data ? 
              <TableRow style={{height: "55px"}}>
                <TableCell><Typography className={`table-col`} style={{color: `${darkMode ? "#8fd1db" : "#172561"}`}}>{data[0].Promotion}</Typography></TableCell>
                <TableCell align="right"><Typography className={`table-col`} style={{color: `${darkMode ? "#8fd1db" : "#172561"}`}}>{moment(data[0][`${filters.extended}`][0].PromoStartDate).format("MM/DD/YYYY")}</Typography></TableCell>
                <TableCell align="right"><Typography className={`table-col`} style={{color: `${darkMode ? "#8fd1db" : "#172561"}`}}>{moment(data[0][`${filters.extended}`][0].PromoEndDate).format("MM/DD/YYYY")}</Typography></TableCell>
                <TableCell align="right"><Typography className={`table-col`} style={{color: `${darkMode ? "#8fd1db" : "#172561"}`}}>{data[0].Format_Desc}</Typography></TableCell>
              </TableRow>
            : null}
          </TableBody>
        </Table>
        {renderStatusTable(roiData)}
        {renderModal()}
        {renderDrawer()}
        <br/>      
        <div          
          className={clsx(classes.chartContent, {[classes.chartShift]: openDrawer || secondaryOpen})}
        >
          <BarChart
            title={"Sales vs Total Sales by Market"}
            data={getChartData()}
            labels={jobData.marketData.map(({Label}) => Label)}
            height={500}
            width={750}
            horizontal={true}
            legend={true}
            position={"bottom"}
            rotate={-45}
            distributed={false}
            darkMode={darkMode}          
          />
          <div>
            {data.length > 0 && data[0].Creative.One ?
            <Fragment>
              <ButtonBase                                    
                  onClick={handleOpenCreative}
              >
                {data[0].Creative["One"] ?
                  <img src={data[0].Creative["One"]} alt="" style={{border: `${darkMode ? "none" : "1px solid #6e6e6e"}`, width: "350px", height: "350px", borderRadius: "8px"}}/>
                :
                  <img src={noImage} alt="" style={{border: `${darkMode ? "none" : "1px solid #6e6e6e"}`, width: "350px", height: "350px", borderRadius: "8px"}}/>
                }
              </ButtonBase>
              <ButtonBase                                    
                onClick={handleOpenCreative}
                style={{marginLeft: "20px"}}
              >
                {data[0].Creative["Two"] ?
                  <img src={data[0].Creative["Two"]} alt="" style={{border: `${darkMode ? "none" : "1px solid #6e6e6e"}`, width: "350px", height: "350px", borderRadius: "8px"}}/>
                :
                  <img src={noImage} alt="" style={{border: `${darkMode ? "none" : "1px solid #6e6e6e"}`, width: "350px", height: "350px", borderRadius: "8px"}}/>
                }
              </ButtonBase>
            </Fragment>
              // Object.keys(data[0].Creative).filter(key => key === "One" || key === "Two").map((key, i) => (
              //   <ButtonBase
              //     key={`${key}-${i}`}
              //     style={key === "Two" ? {marginLeft: "20px", marginTop: `${openDrawer || secondaryOpen ? "25px" : ""}`} : {marginTop: `${openDrawer || secondaryOpen ? "25px" : ""}`}}
              //     onClick={handleOpenCreative}
              //   >
              //     <img src={data[0].Creative[key]} alt={""} className="promo-preview"
              //       style={{width: "350px", height: "350px"}}
              //     />
              //   </ButtonBase>
              // ))
            :
              [...Array(2)].map((item, i) => (
                <img 
                  key={i} 
                  src={noImage} 
                  className="promo-preview" 
                  style={{
                    width: "350px", 
                    height: "350px", 
                    marginLeft: `${i == 1 ? "20px" : "0px"}`,
                    marginTop: `${openDrawer || secondaryOpen ? "25px" : ""}`,
                  }} 
                />              
              ))
            }
            <br/>
            <Typography variant="caption" style={{display: 'flex', justifyContent: 'center', color: `${darkMode ? "#fff" : "#6e6e6e"}`, marginTop: "10px"}}>
              <InfoOutlined fontSize="small" style={{marginRight: '5px', color: '#25aae1'}} /> Images may appear cropped and/or distorted. Click on the Creatives to view each image fully.
            </Typography>
          </div>
        </div>
        <br/>
        <br/>        
        <Tabs
          variant="scrollable"
          value={tab}
          onChange={handleTabChange}
          style={{color: `${darkMode ? "#fff" : "#6e6e6e"}`}}
        >
          <Tab label="View ROI by Location" {...a11yProps(0)} disableRipple/>
          <Tab label="View ROI by RFM Segment" {...a11yProps(1)} disableRipple/>
          <Tab label="View ROI by Test Group" {...a11yProps(2)} disableRipple/>
        </Tabs>        
            
        <TabPanel value={tab} index={0}>
          <br/>
          <EventTabTable
            hide={openDrawer || secondaryOpen}
            data={jobData.locationData}
            dateExtended={filters.extended}
            label={"Location"}
            tab={0}
            categoryColors={categoryColors}
            dark={darkMode}
          />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <br/>
          <EventTabTable
            hide={openDrawer || secondaryOpen}
            data={jobData.rfmData}
            dateExtended={filters.extended}
            label={"RFM Segment"}
            tab={1}
            categoryColors={categoryColors}
            dark={darkMode}
          />
        </TabPanel>

        <TabPanel value={tab} index={2}>
          <br/>
          <EventTabTable
            hide={openDrawer || secondaryOpen}
            data={jobData.testData}
            dateExtended={filters.extended}
            label={"Test Group"}
            tab={2}
            categoryColors={categoryColors}
            dark={darkMode}
          />
        </TabPanel>
      </main>
    </div>
  )
}

export default EventRoiDrawer
